import { MembershipAwarenessSunrise } from '../components/MembershipAwarenessSunrise';
import { useMembershipAwarenessFormFcm } from '../formContext';
import { useMembershipExists } from '../shared/hooks/useMembershipExists';
import type { Props } from '../shared/types';

export function MembershipAwarenessContainerSunrise(props: Props): React.JSX.Element | null {
	const { membershipEnabled } = useMembershipAwarenessFormFcm();
	const membershipExists = useMembershipExists();
	if (!membershipEnabled || membershipExists) return null;

	return <MembershipAwarenessSunrise {...props} />;
}
